var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrencyBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 336,
    height: 119,
    viewBox: "0 0 336 119",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.88 49.346L0 79.1794V99C0 110.046 8.95431 119 20 119H306C322.569 119 336 105.569 336 89V25.8173C334.776 25.0049 332.993 24.7335 332.237 24.6699C326.345 24.1747 322.966 28.8979 318.259 33.2757L318.201 33.33C316.81 34.6252 313.33 37.8654 306.97 37.8654C300.518 37.8654 296.038 34.8056 294.605 33.2757L273.101 9.17949C270.234 6.11966 263.962 0 256.973 0C249.984 0 244.429 6.11966 241.92 9.17949L142.464 111.881C140.851 113.794 135.905 117.618 129.024 117.618C122.143 117.618 117.197 113.794 115.584 111.881L58.0608 46.4774C56.0896 44.1825 50.3194 39.5928 43.008 39.5928C35.6966 39.5928 29.2096 46.0949 26.88 49.346Z",
    fill: "url(#paint0_linear_5_2750)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_2750",
    x1: 168,
    y1: -10.3207,
    x2: 168,
    y2: 138.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyBackground);
export default __webpack_public_path__ + "static/media/currencyBackground.75dacbc5dc225a641f6df0b0cdb960e2.svg";
export { ForwardRef as ReactComponent };